import React, { useEffect, useState } from 'react';
import { IconTrash16, UIHeading4 } from '@cian/ui-kit';
import { useFormContext } from 'react-hook-form';
import { getCountFilledFields } from '../../utils';

import styles from './styles.css';

interface IResetButtonProps {
  defaultFieldCount: number;
  onClick?: () => void;
}

export const ResetButton: React.FC<IResetButtonProps> = ({ defaultFieldCount, onClick }) => {
  const { reset, getValues } = useFormContext();
  const [isShow, setIsShow] = useState(false);

  const formValues = getValues();

  useEffect(() => {
    const countFilledFields = getCountFilledFields(formValues);

    if (countFilledFields > defaultFieldCount) {
      setIsShow(true);
    } else {
      setIsShow(false);
    }
  }, [formValues]);

  const handleReset = () => {
    reset();
    setIsShow(false);
    if (onClick) {
      onClick();
    }
  };

  if (!isShow) {
    return null;
  }

  return (
    <button className={styles.root} onClick={handleReset} data-testid="form-reset-button">
      <span className={styles.clear_icon}>
        <IconTrash16 color="primary_100" />
      </span>
      <UIHeading4 color="primary_100">Очистить</UIHeading4>
    </button>
  );
};
